var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"geometric-search",on:{"click":_vm.GeometricSearch}},[_c('img',{attrs:{"src":_vm.url,"alt":""}}),_c('span',[_vm._v("模型智能检索")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }